export default function Maintenance() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f6fa",
      }}
    >
      <img
        src="/under-maintenance.png"
        alt="Under Maintenance"
        style={{ maxWidth: "80%" }}
      />
    </div>
  );
}
